var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('AudioIcon'),_c('div',{staticClass:"container-text"},[_c('p',[_vm._v(_vm._s(_vm.text))]),_c('img',{staticClass:"forward",attrs:{"src":require("@game/assets/img/arrow.png"),"alt":""},on:{"click":_vm.onForward}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }